import { jsx, Fragment } from "react/jsx-runtime";
import { useCallback } from "react";
import { useTranslation } from "react-i18next";
import { Empty, Button, Icon } from "@perxis-auto/ui-kit";
import { Row } from "@perxis-auto/ui-kit/lib/components/Grid";
import "react-router";
import "@perxis-auto/shared";
import { APP } from "../../../shared/config/app.js";
import "../../../shared/config/env.js";
import "../../../shared/config/events.js";
import "redux";
import { useAppDispatch } from "../../../shared/lib/store/hooks/useAppDispatch.js";
import { useAppSelector } from "../../../shared/lib/store/hooks/useAppSelector.js";
import "../../../shared/lib/store/hooks/useAppStore.js";
import { selectors } from "../../../features/favorite/model/index.js";
import "../../../shared/lib/store/createAppApi.js";
import "../../../shared/lib/store/createAppAsyncThunk.js";
import "../../../shared/lib/store/createAppSelector.js";
import "../../../shared/lib/store/createAppSlice.js";
import { actions } from "../../../features/favorite/model/slice.js";
import { useConstructorContext } from "../../../shared/context/constructor.js";
import "@perxis-auto/shared/lib";
import { useMergedConstructorItemProps } from "../../../shared/lib/constructor/hooks/useMergedConstructorItemProps.js";
import "../../../shared/lib/constructor/mergeConstructor.js";
import { useAppNavigate } from "../../../shared/lib/router/hooks/useAppNavigate.js";
import "@perxis-auto/shared/lib/lib/is/isObject";
import { GET_DEFAULT_CONTAINER_PROPS } from "../config/props.js";
import { Page } from "../ui/page/Page.js";
const useContainer = (item) => {
  const { redirects, ...props } = useMergedConstructorItemProps(item, GET_DEFAULT_CONTAINER_PROPS);
  const { layout, widgets } = useConstructorContext();
  const { t } = useTranslation(APP.name);
  const dispatch = useAppDispatch();
  const navigate = useAppNavigate();
  const {
    options: { offset, limit }
  } = useAppSelector(selectors.selectSlice);
  const totalPages = useAppSelector(selectors.selectFavoriteVehiclesTotalPages);
  const favoriteVehiclesCount = useAppSelector(selectors.selectFavoriteVehiclesCount);
  const pageNum = Math.ceil(offset / limit);
  const isMorePages = pageNum < totalPages - 1;
  const isEmpty = favoriteVehiclesCount === 0;
  const onShowMore = useCallback(() => {
    dispatch(actions.setOffset(offset + limit));
  }, [dispatch, limit, offset]);
  const onBackClick = useCallback(() => {
    navigate(redirects.onBackClick.to, redirects.onBackClick.options);
  }, [navigate, redirects.onBackClick.options, redirects.onBackClick.to]);
  const renderPages = useCallback(() => {
    if (isEmpty) {
      return /* @__PURE__ */ jsx(
        Empty,
        {
          title: t("widgets.favoritesList.empty.title"),
          description: /* @__PURE__ */ jsx(Fragment, { children: t("widgets.favoritesList.empty.description") }),
          children: /* @__PURE__ */ jsx(Button, { type: "ghost", icon: /* @__PURE__ */ jsx(Icon, { name: "forward", sticker: "favorites-list-back-icon" }), onClick: onBackClick, children: t("widgets.favoritesList.empty.backLabel") })
        }
      );
    }
    const pages = [];
    for (let i = 0; i <= pageNum; i++) {
      pages.push(/* @__PURE__ */ jsx(Page, { page: i, redirect: redirects.link, layout, widgets }, i));
    }
    return /* @__PURE__ */ jsx(Row, { gutter: [18, "vertical-sky"], children: pages.map((page) => page) });
  }, [isEmpty, layout, onBackClick, pageNum, redirects.link, t, widgets]);
  return {
    ...props,
    layout,
    widgets,
    renderPages,
    isMorePages,
    onShowMore,
    t
  };
};
export {
  useContainer
};
